import { commitMutation, graphql, Environment } from 'react-relay/legacy';
import { PayloadError } from 'relay-runtime';

import {
    addProjectMutation,
    addProjectMutation$data,
    CreateProjectMutationInput,
} from './__generated__/addProjectMutation.graphql';

type Args = {
    input: CreateProjectMutationInput;
    onCompleted: (
        response: addProjectMutation$data,
        errors: ReadonlyArray<PayloadError> | null | undefined
    ) => void;
    onError: (error: Error) => void;
};

const mutation = graphql`
    mutation addProjectMutation($input: CreateProjectMutationInput!) {
        createProject(input: $input) {
            project {
                serviceId
                createdDate
                name
                portfolio {
                    serviceId
                }
            }
        }
    }
`;

export default function addProject(
    environment: Environment,
    { input, onCompleted, onError }: Args
): void {
    commitMutation<addProjectMutation>(environment, {
        mutation,
        variables: { input },
        onCompleted,
        onError,
    });
}
